import State from "@/helpers/pattern/state";
import { Status } from "@/models/operativos/status";
import { modelIsModified } from "@/helpers/vue-mc";
import statusAPI from "@/services/operativos/status";
import CombosAPI from "@/services/catalogos";
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { clearSwal } from "@/constants/sweet-alerts";
import { scrollToForm } from "@/helpers/form-scroll-to";
import { setSelectsInactiveDataMultipleJson, getJson, setJson } from "@/helpers/form-common";

/**
 * State Pattern for status form
 */
export default class StatusStates extends State {
  /**
   * General Methods
   */
  base() {
    return {
      clear({ $setState }) {
        $setState("initial");
      }
      , async askForClear({ $data }) {
        try {
          if ((await $data.$swal(clearSwal)).value) this.clear();
        } catch (error) {
          console.error(error);
        }
      }
      , resetModel({ $data }) {
        $data.status = new Status();
      }
      , resetValidators({ $data }) {
        $data.$v.$reset();
      }
      , isDisableButtonSubmit({ $data }) {
        return $data.hasErrors($data.$v.status) || $data.view.action.submit.busy || !modelIsModified($data.status);
      }
      , async loadSelectsData({ $data }) {
        const { data: { results: { combo: subStatusList } } } = await CombosAPI.get({ option: "substatus" });
        $data.view.elem.select.substatus.filteredList = subStatusList ? subStatusList.filter((value) => value.status) : [];
        $data.view.elem.select.substatus.completeList = subStatusList || [];
      }
    };
  }

  /**
   * States and their methods
   */
  states() {
    return {
      initial: {
        $constructor: function ({ $data }) {
          // Reset Models and validators
          this.resetModel();
          this.loadSelectsData();
          this.resetValidators();

          // View configuration buttons
          $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.save;
          $data.view.elem.button.submit.title.current = $data.view.elem.button.submit.title.save;
        }
        , async submit({ $data }, { descripcion, canales, substatus, agregador, merchandising, exclusiones, showinapp, status }) {
          try {
            if (!$data.isAllValid($data.$v)) {
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", $data.$t("errors.validof"));
              scrollToForm($data);
              return false;
            }

            $data.view.action.submit.busy = true;

            const response = await statusAPI.save({
              clave: null
              , descripcion
              , canales: canales.join()
              , substatus: setJson(substatus)
              , agregador
              , merchandising
              , exclusiones
              , showinapp
              , status
            });

            $data.view.action.submit.busy = false;
            this.resetModel();
            this.resetValidators();
            $data.$refs.statusTable.refreshData();
            return response;
          } catch (error) {
            console.error(error);
            $data.view.action.submit.busy = false;
            return error;
          }
        }
      }
      , editing: {
        $constructor: function ({ $data }, { clave, descripcion, canales, substatus, agregador, merchandising, exclusiones, showinapp, status }) {
          // View configuration buttons
          $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.update;
          $data.view.elem.button.submit.title.current = $data.view.elem.button.submit.title.update;

          // Set options to combos if not are active
          $data.view.elem.select.substatus.filteredList = setSelectsInactiveDataMultipleJson(substatus, $data.view.elem.select.substatus.completeList);

          $data.status = new Status({
            clave
            , descripcion
            , canales: canales.split(",")
            , substatus: getJson(substatus)
            , agregador
            , merchandising
            , exclusiones
            , showinapp
            , status
          });

          this.resetValidators();
          scrollToForm($data);
        }
        , async submit({ $data, $setState }, { clave, descripcion, canales, substatus, agregador, merchandising, exclusiones, showinapp, status }) {
          try {
            if (!$data.isAllValid($data.$v)) {
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", $data.$t("errors.validof"));
              scrollToForm($data);
              return false;
            }
            $data.view.action.submit.busy = true;

            const response = await statusAPI.update({
              clave
              , descripcion
              , canales: canales.join()
              , substatus: setJson(substatus)
              , agregador
              , merchandising
              , exclusiones
              , showinapp
              , status
            });

            $data.$refs.statusTable.refreshData();
            $data.view.action.submit.busy = false;
            $setState("initial");
            return response;
          } catch (error) {
            console.error(error);
            $data.view.action.submit.busy = false;
            return error;
          }
        }
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/views/operativos/status/status-state.js